import sourcesInitialState from './Sources/initialState';
import alertsInitialState from './Alerts/initialState';
import notificationsManagerEmailInitialState from './NotificationsManager/email/initialState';
import notificationsManagerWebPushInitialState from './NotificationsManager/webPush/initialState';
import notificationsManagerSettingsInitialState from './NotificationsManager/settings/initialState';
import feedbackInitialState from './CaptureFeedback/initialState';
import gdprInitialState from './Gdpr/initialState';
import { SOURCES_MODULE_NAME } from './Sources/constants';
import { ALERT_MODULE_NAME } from './Alerts/constants';

// Default/Initial redux state.

// As a good practice put any property that can exists in the state here as a
// way to document them.
const state = {
  serp: {
    serpOrganicFirstInteraction: true,
    redirectWhere: null,
    redirectWhat: null,
    shouldResetWhere: false,
    isFetching: false,
    title: '', // Title returned by keywords api
    description: '', // Description returned by keywords api
    count: 0,
    similarContentAdsCount: 0,
    didYouMeanWhat: '',
    error: null,
    shouldRetrackAdImpressions: false,
    showingFilters: false,
    ads: [],
    autoComplete: [],
    location: {}, // Location returned by keywords api
    adsVisitCounter: {},
    facets: {},
    adsMeta: {},
    links: {},
    interlinking: {
      selected_seo_links: [],
    },
    osm: {
      items: [],
      ignoreGeoId: false,
    },
    relatedAdsPopup: {
      isShow: false,
      redirectUrl: '',
    },
    searchParameters: {
      routeName: '', // The route name defined in the routes definition.
      pageName: '', // The page that should respond to the route name.
      isSeoUrl: false, // Indicates if we are in SERP section with a SEO friendly URL
      isSemUrl: false, // Indicates if we are in SERP section with a SEM features
      whatOriginalTyped: '', // The original search typed by the user
      what_d: '', // Dirify search term
      whatAccented: '', // Fully accented search term
      where: '', // Jobs where parameter
      type_id: null, // Type of deal
      geoId: null,
      page: 1,
      suggester: null,
      sort: '',
      device: 'mobile',
      isUserSearch: 1,
      carsMake: null,
      carsModel: null,
      filters: {},
      boost_ads_since: null, // Date. Use to return newest ads first.
      isUserFilterInteraction: false, // user manually have changed filters
      isUserSearchInteraction: false,
    },
  },
  featuredAd: {
    data: null,
    isExpired: false,
    error: null,
    alreadyShownOnce: false,
  },
  notifications: {
    subscriptionId: null,
    infrastructureId: null,
    searches: {},
    error: null,
    isExpired: false,
    reset: false,
    isFetching: false,
  },
  adPage: {
    isFetching: false,
    isSendingApply: false,
    ad: null,
    adsContacted: [],
    relatedAds: [],
    isRelatedAdsFetchEnabled: true,
    error: null,
    applyError: null,
  },
  index: {
    isFetching: false,
    seo: [],
    categoryId: 0, // required to products topsearches page
    letter: '', // required to products topsearches page
    numResults: 0,
    error: {},
  },
  notificationsManagerEmail: notificationsManagerEmailInitialState,
  notificationsManagerWebPush: notificationsManagerWebPushInitialState,
  notificationsManagerSettings: notificationsManagerSettingsInitialState,
  feedback: feedbackInitialState,
  gdpr: gdprInitialState,
  suggestions: {
    data: [],
    error: {},
  },
  trovit: {
    host: undefined,
    installationId: '',
    pageviewId: '',
    query: {},
    previousUrl: '',
    url: '',
    origin: 0,
    trackingCodes: {},
    sendingId: null,
    canTriggerTrackingImpressions: true,
    userAgent: '',
    userIp: '',
    device: '',
    abTest: {
      id: '',
      option: '',
      platform: '',
    },
    userCampaignIds: null,
    imagePlaceHolders: {},
  },
  config: {
    countryCode: '', // Country code obtained from the request hostname, ie 'pa'
    verticalId: 1, // Vertical id
    verticalName: '', // Vertical name
    verticalPath: undefined,
    locale: '', // Locale code obtained from the request hostname, ie 'es-PA'
    routes: {}, // Routes configuration for requested country
    vertical: {}, // Configuration for the vertical: like url, codes, etc.
    env: {}, // Environment data: version, environment, hostname, etc
    client: {}, // Client side config: API endpoints, etc
    showDownloadAppBanner: true, // Flag to indicate if we have to show the download app banner
    showPermissionsBanner: true, // Flag to indicate if we have to show the web push notifications banner (custom)
    showPermissionsBannerCounter: 0, // Counter to know how many times user discard the web push notification banner (custom)
    isPushDisallow: false,
    isPushOpen: '',
    lastSearch: '',
  },
  [SOURCES_MODULE_NAME]: sourcesInitialState[SOURCES_MODULE_NAME],
  [ALERT_MODULE_NAME]: alertsInitialState[ALERT_MODULE_NAME],
};

export default state;



// WEBPACK FOOTER //
// ./app/state.js